// extracted by mini-css-extract-plugin
module.exports = {"contents":"Th-z","sectionHeading":"Uh-z"};